{
  "schema_version": 1,
  "task_id": "L5-AIOS-HOME-COMPREHENSION-PASS-001",
  "status": "aios-home-comprehension-pass-ready",
  "source_entry_point": "continue-local-product-polish",
  "generated_at": "2026-07-31T13:10:00+08:00",
  "authority_boundary": {
    "observational_only": true,
    "formal_gate_replacement": false,
    "mutation_authority": false,
    "approval_authority": false,
    "stores_user_decisions": false,
    "collects_secrets": false,
    "cloud_sync": false,
    "ecosystem_publish": false,
    "external_distribution": false,
    "external_write": false,
    "paid_action": false,
    "secret_storage": false,
    "deployment": false,
    "runtime_activation": false,
    "model_call": false,
    "tool_call": false,
    "task_completion_authority": false
  },
  "summary": {
    "one_glance_card_count": 4,
    "creative_flow_step_count": 5,
    "guardrail_count": 8,
    "can_execute_now_count": 0,
    "external_effect_count": 0,
    "secret_values_embedded_count": 0,
    "visible_capability": "desktop-aios-home",
    "adds_new_visible_capability": false,
    "remaining_user_decision_count": 3
  },
  "one_glance_cards": [
    {
      "id": "say-the-idea",
      "title_zh": "先说想法",
      "title_en": "Say the idea first",
      "body_zh": "像使用 Codex 一样从一句话开始，不先看工程表。",
      "body_en": "Start from one sentence like Codex, not from an engineering table.",
      "role": "input",
      "can_execute_now": false
    },
    {
      "id": "route-capabilities",
      "title_zh": "AIOS 编排能力",
      "title_en": "AIOS routes capabilities",
      "body_zh": "把 Codex、本地模型、Skill、GitHub 开源源、浏览器、IDE 与 Runtime 排成可审计路线。",
      "body_en": "Route Codex, local models, Skills, GitHub sources, browser, IDE and Runtime into an auditable path.",
      "role": "orchestration",
      "can_execute_now": false
    },
    {
      "id": "draft-before-action",
      "title_zh": "先草稿，后动作",
      "title_en": "Draft before action",
      "body_zh": "任何强能力先变成 Task Spec、权限账本、Evidence、Rollback 与 Reviewer。",
      "body_en": "Any powerful capability becomes Task Spec, permission ledger, Evidence, rollback and Reviewer first.",
      "role": "governance",
      "can_execute_now": false
    },
    {
      "id": "preview-and-feedback",
      "title_zh": "预览再反馈",
      "title_en": "Preview, then feedback",
      "body_zh": "进入受控预览、截图反馈、继续迭代；真实外部动作仍由用户决策。",
      "body_en": "Enter governed preview, capture feedback, iterate; real external actions remain user-owned decisions.",
      "role": "feedback",
      "can_execute_now": false
    }
  ],
  "creative_flow_steps": [
    {
      "id": "idea",
      "label_zh": "产品想法",
      "label_en": "Product idea",
      "output_zh": "一句话 Brief",
      "output_en": "One-line brief"
    },
    {
      "id": "task-spec",
      "label_zh": "Task Spec 草稿",
      "label_en": "Task Spec draft",
      "output_zh": "范围、验收、风险、回滚",
      "output_en": "Scope, acceptance, risk and rollback"
    },
    {
      "id": "capability-route",
      "label_zh": "能力路线",
      "label_en": "Capability route",
      "output_zh": "Codex / 模型 / Skill / GitHub / IDE 路由",
      "output_en": "Codex / model / Skill / GitHub / IDE route"
    },
    {
      "id": "governed-preview",
      "label_zh": "受控预览",
      "label_en": "Governed preview",
      "output_zh": "只读 receipt、权限与停止条件",
      "output_en": "Read-only receipt, permissions and stop conditions"
    },
    {
      "id": "feedback-loop",
      "label_zh": "体验反馈",
      "label_en": "Experience feedback",
      "output_zh": "截图、修改意见、下一轮迭代",
      "output_en": "Screenshot, feedback and next iteration"
    }
  ],
  "guardrails": [
    "no_execute_button",
    "no_runtime_activation",
    "no_external_write",
    "no_secret_collection",
    "no_approval_authority",
    "no_model_fact_authority",
    "no_paid_action",
    "task_spec_evidence_reviewer_required"
  ],
  "quality_gates": [
    "Task Spec",
    "Evidence",
    "Reviewer",
    "lint/build/test",
    "no external effect",
    "desktop/site shared state",
    "no new visible capability count"
  ],
  "evidence_sources": [
    "artifacts/evidence/GUI-AIOS-HOME-001",
    "artifacts/evidence/GUI-CREATIVE-LOOP-001",
    "artifacts/evidence/L5-CREATIVE-STARTER-SURFACE-001",
    "artifacts/evidence/L5-LOCAL-PRODUCT-POLISH-ROADMAP-001"
  ],
  "links": {
    "desktop_home": "apps/control-console/src/ui/AiosHome.tsx",
    "official_site": "apps/aios-official-site/src/App.tsx",
    "project_status": "config/aios-project-status.json",
    "final_handoff": "config/l5-final-handoff-pack.json"
  }
}
